<template>
  <el-row :gutter="10">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.carrier"
        :primary-fields="[ 'name', 'chainit', 'state', 'enabled']"
        @apply="reload"
        @ready="load"
        @keyup.enter.native="$emit('apply')"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <CarriersTable
          ref="table"
          v-loading="isLoading"
          :carriers-list="carriers"
          @deleteCarrier="deleteCarrier"
        />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="carriers.page"
            :page-size.sync="carriers.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="carriers.total"
            @size-change="reload"
            @current-change="reload"
          />
        </div>
        <CarrierForm
          ref="carrierForm"
          @refreshUpdate="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import CarriersTable from '@/components/Application/Manage/Carriers/Table'
import CarrierForm from '@/components/Application/Manage/Carriers/Form'
import Filters from '@/components/Filters/Simplified'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    CarriersTable,
    CarrierForm,
    Filters
  },
  data () {
    return {
      title: 'Carriers',
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.carrier),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.showCreateForm()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.reload()
          }
        }
      ],
      carriers: [],
      isLoading: true,
      filters: []
    }
  },
  methods: {
    load () {
      this.isLoading = true
      this.$sdk.carrier.list(builder => {
        builder.include = ['carrier_services', 'carrier_group']
        builder.order = 'created_at:desc'
        builder.filters = this.filters
        builder.limit = 20
      }).then(res => {
        this.carriers = res
      }).finally(() => {
        this.isLoading = false
      })
    },
    async reload () {
      this.isLoading = true
      try {
        await this.carriers.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('Failed to load Carriers')
      }
      this.isLoading = false
    },
    deleteCarrier (carrier) {
      this.$confirm('Are you sure to delete this carrier ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        carrier.delete()
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.reload())
      }).catch(() => {})
    },
    showCreateForm () {
      this.$refs.carrierForm.showDialog()
    }
  }
}
</script>
